// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1495":"css/app.6925","7948":"css/admin-app.6925"}[chunkId] + ".css";
};